/* UNDENIABLE — custom cart drawer behavior.
   Quantity / remove via Shopify AJAX Cart API + Section Rendering API (re-renders
   sections/undeniable-cart-drawer.liquid). Open/close reuses the shared overlay (#ovl). */
(function () {
  'use strict';
  var SECTION = 'undeniable-cart-drawer';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function drawer() { return document.getElementById('cart'); }
  function overlay() { return document.getElementById('ovl'); }

  function openCart() {
    var d = drawer(); if (!d) return;
    d.classList.add('on');
    var o = overlay(); if (o) o.classList.add('on');
    document.body.classList.add('lock');
  }
  function closeCart() {
    var d = drawer(); if (d) d.classList.remove('on');
    var o = overlay(); if (o) o.classList.remove('on');
    document.body.classList.remove('lock');
  }

  function updateBubble(count) {
    var b = document.getElementById('cBub');
    if (b) { b.textContent = count; b.classList.toggle('on', count > 0); }
  }

  /* swap the drawer's inner content with freshly-rendered section HTML */
  function applySection(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#cart');
    var cur = drawer();
    if (fresh && cur) {
      /* capture old ship-bar fill so we can animate it smoothly to the new value */
      var oldBarEl = cur.querySelector('.shipbar i');
      var oldW = oldBarEl ? (parseFloat(oldBarEl.style.width) || 0) : 0;

      cur.innerHTML = fresh.innerHTML;

      /* smooth shipping-bar fill: start at old %, then transition to the new % */
      var newBar = cur.querySelector('.shipbar i');
      if (newBar) {
        var targetW = newBar.style.width || '0%';
        var newW = parseFloat(targetW) || 0;
        newBar.style.transition = 'none';
        newBar.style.width = oldW + '%';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { newBar.style.transition = ''; newBar.style.width = targetW; });
        });
        /* celebrate the moment free shipping unlocks */
        if (newW >= 100 && oldW < 100) {
          var ship = cur.querySelector('.ship');
          if (ship) { ship.classList.add('ship--pop'); setTimeout(function () { ship.classList.remove('ship--pop'); }, 1000); }
        }
      }

      /* subtle pulse on the subtotal when it changes */
      var tot = cur.querySelector('[data-cart-total]');
      if (tot) { tot.classList.add('pulse'); setTimeout(function () { tot.classList.remove('pulse'); }, 600); }

      /* keep focus inside the drawer so it can't jump to the skip-to-content link */
      if (cur.classList.contains('on')) {
        var x = cur.querySelector('#cartX');
        if (x) { try { x.focus({ preventScroll: true }); } catch (e) { x.focus(); } }
      }
    }
    var c = tmp.querySelector('[data-cart-count]');
    updateBubble(c ? (parseInt(c.textContent, 10) || 0) : 0);
  }

  var busy = false;
  function change(line, qty) {
    if (busy) return;
    busy = true;
    var d = drawer(); if (d) d.setAttribute('aria-busy', 'true');
    /* on removal, gracefully collapse the item out before the re-render */
    var row = d && d.querySelector('.li[data-line="' + line + '"]');
    var wait = 0;
    if (qty === 0 && row) { row.classList.add('removing'); wait = 260; }
    setTimeout(function () {
      fetch(ROOT + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty, sections: SECTION, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          var html = state && state.sections && state.sections[SECTION];
          if (html) { applySection(html); }
          else { refresh(false); } /* fallback: re-fetch the drawer section standalone */
        })
        .catch(function () { refresh(false); })
        .then(function () { busy = false; if (d) d.removeAttribute('aria-busy'); });
    }, wait);
  }

  /* pull a fresh drawer (used when opening, and after add-to-cart elsewhere) */
  function refresh(openAfter) {
    fetch(ROOT + '?section_id=' + SECTION, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) { applySection(html); if (openAfter) openCart(); })
      .catch(function () { if (openAfter) openCart(); });
  }

  /* delegated clicks survive re-renders */
  document.addEventListener('click', function (e) {
    if (e.target.closest('#cartBtn')) { e.preventDefault(); refresh(true); return; }
    if (e.target.closest('#mnavBag')) { e.preventDefault(); refresh(true); return; }
    if (e.target.closest('#cartX')) { closeCart(); return; }
    var q = e.target.closest('[data-qty]');
    if (q) { change(parseInt(q.getAttribute('data-line'), 10), parseInt(q.getAttribute('data-to'), 10)); return; }
    var r = e.target.closest('[data-rm]');
    if (r) { change(parseInt(r.getAttribute('data-line'), 10), 0); return; }
  });

  /* if anything else changes the cart (add-to-cart on product/collection pages),
     refresh our drawer so the count/contents stay in sync. */
  ['cart:updated', 'cart:refresh', 'cart:change', 'variant:add'].forEach(function (ev) {
    document.addEventListener(ev, function () { refresh(false); });
  });

  /* Auto-open the drawer whenever ANY add-to-cart happens (works with stock Horizon
     product/collection add buttons since those pages aren't rebuilt yet). */
  var isAdd = function (url) { return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url); };
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = (input && input.url) || input || '';
      var p = _fetch.apply(this, arguments);
      if (isAdd(url)) { p.then(function (res) { if (res && res.ok) setTimeout(function () { refresh(true); }, 60); }).catch(function () {}); }
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) { this.__udnUrl = url; return _open.apply(this, arguments); };
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var xhr = this;
    if (isAdd(xhr.__udnUrl)) {
      xhr.addEventListener('load', function () { if (xhr.status >= 200 && xhr.status < 300) setTimeout(function () { refresh(true); }, 60); });
    }
    return _send.apply(this, arguments);
  };

  /* expose a tiny API for future add-to-cart wiring */
  window.UndeniableCart = { open: function () { refresh(true); }, close: closeCart, refresh: refresh };
})();
